<dw-grid-list-page
  [title]="
    !thirdPartyCode() && !articleCode()
      ? ('Doc::Menu:SupplierOpenOrderLines:Open' | abpLocalization)
      : ''
  "
  [activeView]="agGrid.activeView"
  [enableDuplicateBtn]="false"
  [showDuplicateBtn]="false"
  [showDeleteBtn]="false"
  [enableDeleteBtn]="false"
  [showCreationBtn]="false"
  [showExportBtn]="false"
  [hasQuickSearch]="true"
>
  <dw-grid-ag-grid
    [columnDefs]="columns()"
    [datasource]="datasource"
    (rowClicked)="rowClicked($event)"
    (selectedRowsClicked)="selectedRowsClicked($event)"
    #agGrid
    [context]="GoliathDocumentEntityNames.SupplierOpenOrderLines.shortname"
  >
  </dw-grid-ag-grid>
</dw-grid-list-page>
